export const EShapeActionValueChangeColorTarget = wcardinal.ui.EShapeActionValueChangeColorTarget;